export default __webpack_public_path__ + "static/media/most_accurate.ed9f4f43.svg";